<div
  class="dropdown-menu with-pinned-item"
  DMClickOutside
  (clickOutside)="clearContainer()"
  [style.top]="(position | async)?.y + 'px'"
  [style.left]="(position | async)?.x + 'px'"
  [style.width]="(width | async) + 'px'"
  [style.display]="'block'"
>
  <ul class="dropdown-menu-list" (scroll)="callBackFunctions.onScroll($event)" data-e2e-id="dropdown-menu-list">
    <li
      *ngFor="let option of selectOptions$ | async; trackBy: callBackFunctions.trackByValue"
      class="dropdown-menu-item"
      [class.selected]="option.selected"
    >
      <a (click)="callBackFunctions.setValue(option.value)">{{ option.text | translate }}</a>
    </li>
    <li class="dropdown-menu-loader" *ngIf="optionFlags.busy$ | async; else idleBlock">
      <a>
        <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
      </a>
    </li>
    <ng-template #idleBlock>
      <li *ngIf="!optionFlags.hideShowNoMatches && optionFlags.dataSourceEmptyValue && !optionFlags.canAdd" class="dropdown-menu-item">
        <a>{{ staticTextContent.NoMatches | translate }}</a>
      </li>
    </ng-template>
  </ul>

  <div
    class="dropdown-menu-item add-new"
    *ngIf="optionFlags.canAddWidgetData && optionFlags.hasAddPermission"
    data-e2e-id="add-new-item-button"
  >
    <a (click)="callBackFunctions.addNewItem()" *ngIf="!optionFlags.insertable">{{ staticTextContent.NewEntity | translate: { entityName: entityName } }}</a>
    <a
      *ngIf="optionFlags.insertable && (optionFlags.insertableVisibility$ | async)"
      (click)="callBackFunctions.addNewItem()"
    >
      <strong>{{ searchControl.value }}</strong> {{ staticTextContent.AddNew | translate }}
    </a>
  </div>
</div>
